export default __webpack_public_path__ + "static/media/CA-2 Create an app.cde03a93.png";